import { render, staticRenderFns } from "./KnowledgeBaseTab.vue?vue&type=template&id=90d04472&scoped=true&"
import script from "./KnowledgeBaseTab.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseTab.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseTab.vue?vue&type=style&index=0&id=90d04472&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d04472",
  null
  
)

export default component.exports